import styles from './WorkflowDiagramConnectionStep.module.css';

export const WorkflowDiagramConnectionStepDivider = () => {
  return <div className={styles.workflowDiagramConnectionStepDivider} />;
};
